import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
	{
		path: '/archimedes',
		name: 'Archimedes',
		component: () => import('../views/curves/Archimedes.vue')
	},
	{
		path: '/hyperbolic_spiral',
		name: 'Hyperbolic Spiral',
		component: () => import('../views/curves/HyperbolicSpiral.vue')
	},
	{
		path: '/limacon',
		name: 'Limacon',
		component: () => import('../views/curves/LimaconPascal.vue')
	},
	{
		path: '/logarithmic_spiral',
		name: 'Logarithmic Spiral',
		component: () => import('../views/curves/LogarithmicSpiral.vue')
	},
	{
		path: '/lemniscata_bernoulli',
		name: 'Lemniscata Bernoulli',
		component: () => import('../views/curves/LemniscataBernoulli.vue')
	},
	{
		path: '/strophoid',
		name: 'Strophoid',
		component: () => import('../views/curves/Strophoid.vue')
	},
	{
		path: '/roses',
		name: 'Roses',
		component: () => import('../views/curves/Roses.vue')
	},
	{
		path: '/epicycloid',
		name: 'Epicycloid',
		component: () => import('../views/curves/Epicycloid.vue')
	},
	{
		path: '/cardioid',
		name: 'Cardioid',
		component: () => import('../views/curves/Cardioid.vue')
	},
	{
		path: '/astroid',
		name: 'Astroid',
		component: () => import('../views/curves/Astroid.vue')
	},
	{
		path: '/*',
		name: '404',
		component: () => import('../views/404.vue')
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
